exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._96RnSpmcBngSICMKytoYu{color:#c50e2e}._1iHLYYsAqT1IOR_v1qgfxs{display:inline-block}", ""]);

// exports
exports.locals = {
	"linkWithSharingIssue": "_96RnSpmcBngSICMKytoYu",
	"link": "_1iHLYYsAqT1IOR_v1qgfxs"
};